import { ConsumedStatuses } from "shared/constants";
import { MaterialConsumedItem } from "shared/api";

export const renderConsumedStatuses = (item: MaterialConsumedItem) => {
  if (item.status === ConsumedStatuses.LO) return "Lost";
  if (item.status === ConsumedStatuses.US) return "Used";
  if (item.status === ConsumedStatuses.WA) return "Wasted";
  return "Unknown status";
};
